import { ComposeViewState, ComposeControl } from 'owa-mail-compose-store';
import { findComposePlugins } from '../plugins/ComposePlugins';
import { getTotalRecipientCount } from './viewStateUtils';

export default function getAutoFocusControl(viewState: ComposeViewState): ComposeControl {
    const plugins = findComposePlugins(viewState);
    const hasCursorSnapshot = plugins && plugins.contentOperation.hasCursorSnapshot();
    if (!hasCursorSnapshot && !viewState.isInlineCompose) {
        if (getTotalRecipientCount(viewState) == 0) {
            return ComposeControl.RecipientWellTo;
        } else if (!viewState.subject) {
            return ComposeControl.SubjectLine;
        }
    }

    return ComposeControl.Editor;
}
